export const LIMIT_TO_SEE_ALL = 4;

export const RewardType = {
  VOUCHER: 1,
  POINTS: 2,
  BADGE: 3,
  POINTS_MULTIPLIER: 11,
} as const;

export const RewardStatusType = {
  VALID: 1,
  EXPIRED: 2,
  BURNED: 3,
  PENDING: 4,
  PROCESSING: 5,
} as const;

export const TriggerId = {
  POINTS: 1,
  VOUCHERS: 2,
  TIER: 3,
} as const;

export const Operator = {
  AND: 1,
  OR: 2,
} as const;
